import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import ModalConfirmUserDeletion from "src/common/components/Modal/ModalConfirmUserDeletion";
import Navigation from "src/common/components/Navigation/Navigation";

const TemplatesWrapper = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <Navigation
        title={t("pages.templates.title")}
        showGoBackButton={location.pathname !== "/templates/" && location.pathname !== "/templates"}
        backDepth={1}
      />

      <Outlet />
      <ModalConfirmUserDeletion />
    </>
  );
};

export default TemplatesWrapper;
